import { render } from "./TableColumnHeader.vue?vue&type=template&id=2f4a8880"
import script from "./TableColumnHeader.vue?vue&type=script&lang=js"
export * from "./TableColumnHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__